/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_Dialog_TitleInputs */

const en_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Y Position`)
};

const fr_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définir la Position Y`)
};

const de_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Y-Position festlegen`)
};

const it_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta la posizione Y`)
};

const ru_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить положение по оси Y`)
};

const es_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer la posición Y`)
};

const zh_cn2_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置 Y 轴位置`)
};

const ja_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Y位置を設定`)
};

const hi_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Y स्थिति निर्धारित करें`)
};

const pt_pt2_input_position_y_dialog_title = /** @type {(inputs: Input_Position_Y_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina a posição Y`)
};

/**
* | output |
* | --- |
* | "Set Y Position" |
*
* @param {Input_Position_Y_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_dialog_title = /** @type {((inputs?: Input_Position_Y_Dialog_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Dialog_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_y_dialog_title(inputs)
	if (locale === "de") return de_input_position_y_dialog_title(inputs)
	if (locale === "it") return it_input_position_y_dialog_title(inputs)
	if (locale === "ru") return ru_input_position_y_dialog_title(inputs)
	if (locale === "es") return es_input_position_y_dialog_title(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_y_dialog_title(inputs)
	if (locale === "ja") return ja_input_position_y_dialog_title(inputs)
	if (locale === "hi") return hi_input_position_y_dialog_title(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_y_dialog_title(inputs)
	return en_input_position_y_dialog_title(inputs)
});